module.exports = __webpack_public_path__ + "static/media/nengli6.780b1e8d.png";